import { Box, BoxProps, Image } from '@chakra-ui/react';

type ArteInformativoProps = BoxProps & {
	src: string;
	alt: string;
};

/**
 * A arte de um informativo inteira, sem corte, em qualquer proporção.
 *
 * O cartaz traz o recado impresso, e o mural não sabe que formato a escola vai
 * mandar: o banner de feriados é seis vezes mais largo que alto, o cartaz de
 * evento costuma vir em pé. Com `cover` numa caixa de altura fixa, o que não
 * cabia era cortado - as colunas das pontas do banner sumiam. Aqui a arte entra
 * com `contain`, e a sobra da caixa é preenchida por uma cópia desfocada da
 * própria arte, para não virar faixa preta e o banner manter as cores dela.
 *
 * Quem usa define o tamanho da caixa; a arte se ajusta a ele.
 */
export const ArteInformativo = ({ src, alt, ...caixa }: ArteInformativoProps) => (
	<Box position="relative" overflow="hidden" bgColor="blue.900" {...caixa}>
		{/* Decorativa: a mesma imagem já está logo abaixo, com o alt. O `scale`
		    empurra para fora da caixa a borda clara que o blur cria. */}
		<Image
			src={src}
			alt=""
			aria-hidden
			position="absolute"
			inset="0"
			width="100%"
			height="100%"
			objectFit="cover"
			filter="blur(24px) brightness(0.7)"
			transform="scale(1.2)"
		/>
		<Image src={src} alt={alt} position="relative" width="100%" height="100%" objectFit="contain" />
	</Box>
);
